module.exports = __webpack_public_path__ + "img/UI_4NIU3D_TLEBZ_01_dafc97432.png";